import ServiceManagement from "../../../components/units/Progix/Service/ServiceManagement";

export default function ServiceManagementPage() {
  return <ServiceManagement />;
}
